import { jsx as _jsx } from "react/jsx-runtime";
import { memo } from 'react';
import { TabLayout } from 'console/shared/components/tab/layout';
import { SocketModelView } from 'console/shared/components/panels/sockets';
export const SocketsTabContent = memo(function SocketsTabContent() {
    return (_jsx(TabLayout, { px: 2, py: 1, height: "100%", overflow: "auto", support_tab_control: false, children: _jsx(SocketModelView, {}) }));
});
